import { render, staticRenderFns } from "./Etherpad.vue?vue&type=template&id=92167282&scoped=true&lang=pug&"
import script from "./Etherpad.vue?vue&type=script&lang=coffee&"
export * from "./Etherpad.vue?vue&type=script&lang=coffee&"
import style0 from "./Etherpad.vue?vue&type=style&index=0&id=92167282&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92167282",
  null
  
)

component.options.__file = "Etherpad.vue"
export default component.exports